'use client'

import { useState, useEffect, useCallback } from 'react';
import { Modal } from './Modal';
import { PurchaseFlow } from './PurchaseFlow';
import { useAccount } from 'wagmi';

interface PurchaseModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialStep?: number;
}

export const PurchaseModal = ({ isOpen, onClose, initialStep }: PurchaseModalProps) => {
  const { isConnected, address } = useAccount();
  
  const [currentStep, setCurrentStep] = useState(1);
  const [totalSteps, setTotalSteps] = useState(5); // Default to 5, updated by PurchaseFlow
  
  // Log the current state of wallet connection for debugging
  useEffect(() => {
    console.log('PurchaseModal: Wallet connection state:', { isConnected, address });
  }, [isConnected, address]);
  
  // Determine the starting step based on wallet connection state if not provided
  const startAtStep = initialStep || (isConnected && address ? 2 : 1);

  // Callback for PurchaseFlow to update the step state
  const handleStepChange = useCallback((step: number, total: number) => {
    setCurrentStep(step);
    setTotalSteps(total);
    console.log(`PurchaseModal: Step changed to ${step}/${total}`);
  }, []);

  // Effect to initialize step state when modal opens or initialStep changes
  useEffect(() => {
    if (isOpen) {
      handleStepChange(startAtStep, totalSteps); // Initialize with startAtStep
    }
    // Reset step when modal closes if needed (optional)
    // return () => {
    //   if (!isOpen) {
    //     handleStepChange(1, 5); 
    //   }
    // };
  }, [isOpen, startAtStep, handleStepChange, totalSteps]); // Added dependencies

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      title="GAM Token Presale"
      currentStep={currentStep} // Pass current step
      totalSteps={totalSteps}   // Pass total steps
    >
      <PurchaseFlow 
        onClose={onClose} 
        initialStep={startAtStep} 
        onStepChange={handleStepChange} // Pass the callback
      />
    </Modal>
  );
}; 